import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AppContext } from "@/context/AppContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";

export default function Layout() {
  const navigate = useNavigate();
  const openApp = (track = null) => navigate(track ? `/apply?cohort=${track}` : "/apply");

  return (
    <AppContext.Provider value={{ openApp }}>
      <Nav />
      <main className="pt-16">
        <Outlet />
      </main>
      <Footer />
    </AppContext.Provider>
  );
}
